/**
 * Results Section Component
 *
 * Displays evaluation results in card format:
 * - Header with count
 * - List of ResultCard components
 * - Each card shows question, response, feedback form
 */

import React from 'react';
import { EvaluationResult } from '../../api/evaluation';
import { ResultCard } from './ResultCard';

interface ResultsSectionProps {
  results: EvaluationResult[];
  readOnly?: boolean;
}

export const ResultsSection: React.FC<ResultsSectionProps> = ({ results, readOnly = false }) => {
  return (
    <div>
      {/* Header */}
      <div className="mb-6">
        <h2 className="text-2xl font-semibold text-gray-900">
          Evaluation Results ({results.length})
        </h2>
        <p className="mt-1 text-gray-600">
          Review each result and provide your feedback
        </p>
      </div>

      {/* Results Cards */}
      <div className="space-y-4">
        {results.map((result, index) => (
          <ResultCard key={result.item_id} result={result} index={index + 1} readOnly={readOnly} />
        ))}
      </div>

      {/* Summary Footer */}
      <div className="mt-6 bg-green-50 border border-green-200 rounded-lg p-4">
        <p className="text-sm text-green-800">
          <i className="pi pi-check-circle mr-2" />
          All {results.length} results loaded successfully. Please review and provide feedback.
        </p>
      </div>
    </div>
  );
};
